import { combineReducers } from 'redux'
import { authReducer } from './auth'
import { contractorPortalAuthReducer } from './contractorPortalAuth'
import { contractorPortalPartnersReducer } from './contractorPortalPartners'
import { contractorPortalInvoicesReducer } from './contractorPortalInvoices'
import { contractorPortalDocumentsReducer } from './contractorPortalDocuments'
import { contractorPortalCertificatesReducer } from './contractorPortalCertificates'
import { documentsReducer } from './documents'
import { partnerReducer } from './partner'
import { driverReducer } from './driver'
import { recollectionReducer } from './recollection'
import { remoteConfigReducer } from './remoteConfig'

export const rootReducer = combineReducers({
  auth: authReducer,
  contractorPortalAuth: contractorPortalAuthReducer,
  contractorPortalPartners: contractorPortalPartnersReducer,
  contractorPortalInvoices: contractorPortalInvoicesReducer,
  contractorPortalDocuments: contractorPortalDocumentsReducer,
  contractorPortalCertificates: contractorPortalCertificatesReducer,
  documents: documentsReducer,
  driver: driverReducer,
  partner: partnerReducer,
  recollection: recollectionReducer,
  remoteConfig: remoteConfigReducer,
})
